/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Task_Status_CompleteInputs */

const en_attribute_task_status_complete = /** @type {(inputs: Attribute_Task_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete`)
};

/**
* | output |
* | --- |
* | "Complete" |
*
* @param {Attribute_Task_Status_CompleteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_task_status_complete = /** @type {((inputs?: Attribute_Task_Status_CompleteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Task_Status_CompleteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_task_status_complete(inputs)
});